import { useNg } from "@sazka/ng/ng-integration";
import { ngOpenPage } from "./ng-open-page";
import { useNgCasinoLib } from "@sazka/casino/js/core/use-ng-casino";
import { useLottery3DSRedirection } from "@/lotteries/utils/use-lottery-3ds-redirection";
import { useCasinoHeader } from "@/shared/composables/use-casino-header";

export const useNgLib = async () => {
    await useNg(ngOpenPage);
    await useNgCasinoLib();
    await useLottery3DSRedirection();

    useCasinoHeader();
};
